export const DAY_OFF = 1;
export const VOCATION = 2;
export const SICK_LEAVE = 3;
export const LOCKED_TIME = 4;

export default Object.freeze({
  DAY_OFF,
  VOCATION,
  SICK_LEAVE,
  LOCKED_TIME
});
